// src/services/admin.js
import api from './api';

export const getAdminUsers = async () => {
  const response = await api.get('/admin/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/admin/users', userData);
  return response.data;
};

export const updateUserRole = async (userId, roleData) => {
  const response = await api.put(`/admin/users/${userId}/role`, roleData);
  return response.data;
};

export const toggleUserStatus = async (userId, statusData) => {
  const response = await api.put(`/admin/users/${userId}/status`, statusData);
  return response.data;
};

export const resetUserPassword = async (userId) => {
  const response = await api.post(`/admin/users/${userId}/reset-password`);
  return response.data;
};

export const getSystemLogs = async () => {
  const response = await api.get('/admin/logs');
  return response.data;
};